import React from 'react'

const HeaderModal = ({headerText, headerTag}) => {

 

  if (headerTag === "h1")
    return (
      <div className="header-modals">
          <h1>{headerText}</h1>
        </div>)
  else if (headerTag === "h2")
    return (
      <div className="header-modals">
          <h2>{headerText}</h2>
      </div>)
  else if (headerTag === "h3")
    return (
      <div className="header-modals">
          <h3>{headerText}</h3>
      </div>)
  else if (headerTag === "h4")
  return (
    <div className="header-modals">
        <h4>{headerText}</h4>
    </div>)
  else if (headerTag === "h5")
  return (
    <div className="header-modals">
        <h5>{headerText}</h5>
    </div>)
  else if (headerTag === "h6")
    return (
      <div className="header-modals">
          <h6>{headerText}</h6>
      </div>)
  else  
      return <></>
  
}

export default HeaderModal